import Menu from '../Menu';
import Routing from '../Routing';

export default function Body() {
  return (
    <div align="center">
      <table width="656" border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td width="207">
            <Menu />
          </td>
          <td width="450" height="566" align="center" valign="top">
            <table border="0" cellpadding="0" cellspacing="0" width="450">
              <tr>
                <td
                  colspan="3"
                  background="/assets/im_r1_c1.jpg"
                  width="450"
                  height="11"
                />
                <td background="/assets/blank.gif" width="1" height="11" />
              </tr>
              <tr>
                <td background="/assets/im_r2_c1.jpg" width="8" height="539" />
                <td
                  align="center"
                  valign="top"
                  background="/assets/im_r2_c2.jpg"
                >
                  <Routing />
                </td>
                <td background="/assets/im_r2_c3.jpg" width="12" />
                <td background="/assets/blank.gif" width="1" />
              </tr>
              <tr>
                <td
                  colspan="3"
                  background="/assets/im_r3_c1.jpg"
                  width="450"
                  height="8"
                />
                <td background="/assets/blank.gif" width="1" height="8" />
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  );
}
